<template>
  <div v-if="!template" class="container-fluid">
    <div class="row">
      <div class="col-lg-6 col-md-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">
              Available Templates
            </h4>
            <h6 class="card-subtitle">
              Audit templates already stored
            </h6>
          </div>
          <div v-if="certifications.length>0" class="card-body">
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th scope="col">
                      #
                    </th>
                    <th class="text-left" scope="col">
                      Name
                    </th>
                    <th class="text-left" scope="col">
                      Version
                    </th>
                    <th class="text-left" scope="col">
                      Description
                    </th>
                    <th class="text-center" scope="col">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(certification, index) in certifications" :key="index">
                    <td class="masked">
                      {{ index + 1 }}
                    </td>
                    <td class="text-left masked">
                      {{ certification.audit_name }}
                    </td>
                    <td class="text-left masked">
                      {{ certification.version }}
                    </td>
                    <td :title="certification.description" class="text-left masked">
                      {{ certification.description }}
                    </td>
                    <td class="text-center masked">
                      <label class="switch">
                        <input checked type="checkbox">
                        <span class="slider" />
                      </label>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div v-else class="card-body">
            <h4 class="card-title text-muted text-center">
              No records found
            </h4>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">
              Upload Template
            </h4>
            <h6 class="card-subtitle">
              Upload audit template
            </h6>
          </div>

          <div class="card-body form-group row">
            <div class="col-md-12 upload-form form-group">
              <form class="form-horizontal" @submit.prevent="handleSubmit">
                <div class="form-group row">
                  <label class="control-label col-md-2">Name</label>
                  <div class="col-md-10 text-left">
                    <input id="name" v-model="audit_name" v-validate="'required'" :class="{'is-invalid': submitted && errors.has('name')}" class="form-control" data-vv-as="Audit Name" name="name" type="text">
                    <div v-if="submitted && errors.has('name')" class="invalid-feedback">
                      {{ errors.first('name') }}
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="control-label col-md-2">Version</label>
                  <div class="col-md-10 text-left">
                    <input id="version" v-model="version" v-validate="'required'" :class="{'is-invalid': submitted && errors.has('version')}" class="form-control" data-vv-as="Version" name="version" type="text">
                    <div v-if="submitted && errors.has('version')" class="invalid-feedback">
                      {{ errors.first('version') }}
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="control-label col-md-2">About</label>
                  <div class="col-md-10 text-left">
                    <textarea id="desc" v-model="description" class="form-control" name="desc" placeholder="Description" rows="4" type="text" />
                  </div>
                </div>
                <div class="form-group row">
                  <label class="control-label col-md-2">Upload Template</label>
                  <div class="col-md-9 text-left">
                    <div class="input-group mb-1">
                      <div class="custom-file">
                        <input id="file" ref="file" v-validate="'required'" :class="{'is-invalid': submitted && errors.has('file')}" accept=".xls,.xlsx" class="custom-file-input" data-vv-as="Attachment" name="file" type="file" @change="onFileChange()">
                        <label class="custom-file-label text-ellipsis">{{ filename }}</label>
                      </div>
                    </div>
                    <div v-if="submitted && errors.has('file')" class="invalid-feedback">
                      {{ errors.first('file') }}
                    </div>
                  </div>
                  <div class="col-md-1 text-right">
                    <a class="btn btn-info rounded btn-icon" download href="/Audit_Template.xlsx" title="Export Template">
                      <i class="fas fa-download" />
                    </a>
                  </div>
                </div>
                <div class="form-group row float-right">
                  <div class="button-group">
                    <button class="btn waves-effect waves-light btn-success" type="submit">
                      Preview
                    </button>
                    <button class="btn waves-effect waves-light btn-secondary" type="button">
                      Reset
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <audit-template v-else :audit="template" />
</template>

<script>
import AuditTemplate from './preview/AuditTemplate.vue'

export default {
  name: 'AddTemplate',
  components: { AuditTemplate },
  data () {
    return {
      certifications: [],
      submitted: false,
      file: null,
      filename: 'Choose File',
      error: [],
      audit_name: null,
      description: null,
      version: null,
      template: null
    }
  },
  mounted () {
    this.getCertifications()
    $('.loader-gif').hide()
  },
  methods: {
    async getCertifications () {
      try {
        const { data } = await this.$api.get('/audits/certifications')
        this.certifications = data.templates
      } catch (e) {
        console.error(e)
      }
    },
    handleSubmit () {
      this.submitted = true
      this.$validator.validate()
        .then(valid => {
          if (valid) {
            this.importExcel()
          }
        })
    },
    async onFileChange () {
      this.file = this.$refs.file.files[0]
      this.filename = this.file.name
    },
    async importExcel () {
      try {
        $('.upload-form').hide()
        $('.loader-gif').show()
        const formData = new FormData()
        formData.append('file', this.file)
        const { data } = await this.$apiFile.post('/templates/import', formData)
        this.template = data
      } catch (e) {
        this.$toastr.e('Failed to save template', 'Failed!')
        console.error(e)
      } finally {
        $('.loader-gif').hide()
        $('.upload-form').show()
      }
    },
    reset () {
      this.template = null
      this.audit_name = null
      this.description = null
      this.version = null
      this.file = null
      this.filename = null
    }
  }
}
</script>

<style scoped>
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #2196f3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>
